/**
 * Map of existing Auth roles in the backend
 *
 * If this enum is updated, be sure to update the enum in AWSJamGameService and JamAdminService -> AuthRole.java
 */
export enum AuthRole {
  GUEST_USER = 'guest-user',
  SUBSCRIBED_USER = 'subscribed-user',
  EVENT_SUPPORT = 'event-support',
  CHALLENGE_SUPPORT = 'challenge-support',
  CHALLENGE_BUILDER = 'challenge-builder',
  CHALLENGE_REVIEWER = 'challenge-reviewer',
  /**
   * Grants viewing and editing a challenge's translations, and nothing else.
   * Deliberately does not imply CHALLENGE_BUILDER, so it must never be treated
   * as an authoring role. JAM_ADMIN expands to include this role.
   */
  CHALLENGE_TRANSLATOR = 'challenge-translator',
  JAM_ADMIN = 'jam-admin',
  SBTS_LEARNER = 'sbts-learner',
}
